<template>
  <div>
    <div class="no-have-references" v-if="not_have_references != null">
      <div :class="typeMessage" role="alert" v-if="message != ''">
        {{message}}
      </div>

      <div class="row">
        <div class="container">
          <h2>En caso de que el candidato no cuente con referencias por favor diligencie este formulario. Debe quedar claro el motivo por el cual el candidato no posee referencias</h2>
        </div>
        <label class="col-sm-3 col-form-label">El aspirante cuenta con referencias académicas ?<label class="text-danger">*</label></label>
        <div class="col-md-9">
          <label class="switch">
            <input type="checkbox" class="form-control" v-model="not_have_references">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="row reason" v-if="!not_have_references">
        <label class="col-md-3 control-label" for="">Por qué razón no cuenta con referencias académicas ?</label>
        <div class="col-md-6">
          <textarea class="form-control" id="exampleFormControlTextarea1" v-model="project.reason_not_have_academic_references" rows="3"></textarea>
          <span class="help-block">Diligencie este campo solo si el candidato no cuenta con referencias académicas</span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <button class="btn btn-primary btn-lg btn-block" @click.prevent="saveReason">Guardar</button>
        </div>
      </div>
    </div>
    <div class="form-group" v-if="not_have_references">
      <div class="col-md-12">
        <h1>Información académica</h1>
      </div>

      <div v-if="loading" style="height: 80vh;
    position: absolute;
    z-index: 7;
    display: flex;
    justify-content: center;
    width: 86vw;
    opacity: 0.5;
    background: darkgray;">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
      </div>



      <div>
        <label class="col-md-3 control-label" for="">Tipo de referencia académica</label>
        <div class="col-md-9">
          <select v-validate="'required'" name="referenceType" class="form-control" v-model="academic_reference.academic_type">
            <option disabled value="">Selecciones el tipo de referencia académica</option>
            <option v-for="(academic_type, index) in academic_types" :key="index" v-bind:value="academic_type.id">{{academic_type.name}}</option>
          </select>
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('referenceType') != null ? 'Requerido*' : '' }}</span>
        </div>

        <label class="col-md-3 control-label" for="">Pais</label>
        <div class="col-md-9">
          <select class="form-control" v-model="country">
            <option disabled value="">Seleccione un pais</option>
            <option v-for="(country, index) in countries" :key="index" v-bind:value="country.id">{{country.name}}</option>
          </select>
          <span class="help-block"></span>
        </div>

        <label class="col-md-3 control-label" for="">Ciudad</label>
        <div class="col-md-9">
          <select v-validate="'required'" name="city" class="form-control" v-model="academic_reference.city_id">
            <option disabled value="">Seleccione una ciudad</option>
            <option v-for="city in cities" :key="city.id" v-bind:value="city.id">{{city.name}}</option>
          </select>
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('city') != null ? 'Requerido*' : '' }}</span>
        </div>

        <label class="col-md-3 control-label" for="">Nivel</label>
        <div class="col-md-9">
          <select v-validate="'required'" name="level" class="form-control" v-model="academic_reference.level">
            <option disabled value="">Seleccione el nivel de la referencia académica</option>
            <option v-for="(level, index) in levels" :key="index" v-bind:value="level.id">{{level.name}}</option>
          </select>
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('level') != null ? 'Requerido*' : '' }}</span>
        </div>

        <label class="col-md-3 control-label" for="">Institución</label>
        <div class="col-md-9" v-if="academic_reference.level > 1 && !not_institution">
          <select v-validate="'required'" name="institution" v-if="!not_institution && country == 1" class="form-control" v-model="academic_reference.name_institution" id="">
            <option v-for="institution in institutions" :key="institution.nombre_instituci_n" :value="institution.nombre_instituci_n">
              {{institution.nombre_instituci_n}}
            </option>
          </select>
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('institution') != null ? 'Requerido*' : '' }}</span>
        </div>

        <div class="col-md-9" v-if="!academic_reference.level || academic_reference.level < 2 || not_institution || country != 1">
          <input v-validate="'required'" name="institution" type="text" class="form-control" v-model="academic_reference.name_institution">
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('institution') != null ? 'Requerido*' : '' }}</span>
        </div>

        <label for="" class="col-md-3"></label>
        <div class="col-md-9">
            <label v-if="country == 1" for="">¿No encuentras la institucion? Agregalo manualmente</label>
            <input v-if="country == 1" type="checkbox" name="" v-model="not_institution" id="">
        </div>


        <label class="col-md-3 control-label" for="">Título obtenido</label>
        <div class="col-md-9">
          <input v-validate="'required'" name="title" class="form-control" type="text" v-model="academic_reference.name_title">
          <span class="help-block" style="font-size:14px; color:red;">{{ errors.first('title') != null ? 'Requerido*' : '' }}</span>
        </div>

        <label class="col-md-3 control-label" for="">Fecha de graduación</label>
        <div class="col-md-9">
          <input class="form-control" type="date" v-model="academic_reference.date_graduation">
          <span class="help-block">Ingrese la fecha de graduación</span>
        </div>

        <label class="col-md-3 control-label" for="">Grafología</label>
        <div class="col-md-9">
          <select class="form-control" v-model="academic_reference.graphology">
            <option disabled value="">Seleccione el resultado de la grafología</option>
            <option :value="0">No realizada</option>
            <option :value="1">Confiable</option>
            <option :value="2">No confiable</option>
          </select>
          <span class="help-block">Seleccione el resultado de la grafología</span>
        </div>

        <label class="col-md-3 control-label" for="">Observaciones encontradas en la grafología</label>
        <div class="col-md-9">
          <textarea class="form-control" id="exampleFormControlTextarea1" v-model="academic_reference.graphology_observations" rows="3"></textarea>
          <span class="help-block">Ingrese las observaciones encontradas en la grafología</span>
        </div>

        <label class="col-md-3 control-label" for="">Observaciones</label>
        <div class="col-md-9">
          <select class="form-control" id="selec-observation" v-model="academic_reference.observations">
            <option disabled value="">Selecciones el tipo de referencia académica</option>
            <option v-for="observation in observations" :key="observation.id" v-bind:value="observation.name">{{observation.name}}</option>
          </select>
        </div>

        <label class="col-md-3 control-label" for="">Observaciones</label>
        <div class="col-sm-9">
            <div class="col-sm-5" style="padding: 0;">
              <textarea type="text" class="form-control no-resize" rows="10" cols="10" v-model="academic_reference.observations"></textarea>
            </div>

            <div class="col-md-2 align-self-center">
              <button id="improve-text-laboral" class="btn btn-info" type="button" style="width: 100%;" :disabled="disabeGPT" @click.prevent="callServiceChat()">
                <span v-if="spinner" class="spinner-border"></span>
                <span v-else>Transformar</span>
              </button>
            </div>

            <div class="col-sm-5" style="padding: 0;">
              <textarea type="text" class="form-control no-resize" rows="10" cols="10" readonly=true v-model="this.observations_ia"></textarea>
            </div>

            <div class="col-md-5">
              <div class="custom-control custom-radio">
                <input type="radio" id="obs_by_analist_laboral" value="obs_by_analist" class="custom-control-input" v-model="selected_obs_with_ia">
                <label class="custom-control-label">Usar texto original</label>
              </div>
            </div>

            <div class="col-md-2"></div>

            <div class="col-md-5">
              <div class="custom-control custom-radio">
                <input type="radio" id="obs_by_ia_laboral" value="obs_by_ia" class="custom-control-input" v-model="selected_obs_with_ia">
                <label class="custom-control-label">Usar texto recomendado por IA</label>
              </div>
            </div>
        </div>


      <div class="form-group form-actions">
        <button @click.prevent="save" class="btn btn-success">Guardar</button>
        <button @click.prevent="academic_reference = {}" class="btn btn-warning">Limpiar</button>
      </div>
      <div>
        <span role="alert" v-if="errors.items.length > 0" class="alert alert-danger">
          Uno o mas campos requeridos no fueron diligenciados, por favor valida e intenta nuevamente
        </span>
      </div>
      <div :class="typeMessage" role="alert" v-if="message != ''">
        {{message}}
      </div>
      <table class="table table-condensed" id="table-academic-references">
        <thead>
            <tr>
                <th>id</th>
                <th>Proceso</th>
                <th>Tipo</th>
                <th>Nivel</th>
                <th>Institución</th>
                <th>Título</th>
                <th>Graduación</th>
                <th>Ciudad</th>
                <th>Referencia Verificada</th>
                <th>Correos</th>
                <th>Editar</th>
                <th>Eliminar</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(academic_reference_iterator, index) in academic_references_local" :key="academic_reference_iterator.id">
            <template v-if="academic_reference_iterator.name_institution != null && academic_reference_iterator.name_institution != ''">
              <td>{{academic_reference_iterator.id}}</td>
              <td>{{academic_reference_iterator.project_id}}</td>
              <td>{{academic_reference_iterator.academic_type | academicTypeName }}</td>
              <td>{{academic_reference_iterator.level | levelName }}</td>
              <td>{{academic_reference_iterator.name_institution}}</td>
              <td>{{academic_reference_iterator.name_title}}</td>
              <td>{{academic_reference_iterator.date_graduation}}</td>
              <td>{{academic_reference_iterator.city_name}}</td>
              <td>{{academic_reference_iterator.verification_response | trueOrFalse}}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-info"
                  @click.prevent="goToComposeEmail(academic_reference_iterator.project_id, 'academic', academic_reference_iterator.id)">
                  Redactar
                </button>
              </td>
              <td>
                <button @click.prevent="edit(academic_reference_iterator)" type="button" class="btn btn-success">Editar</button>
              </td>
              <td>
                <button @click.prevent="deleteAcademicReference(academic_reference_iterator, index)" type="button" class="btn btn-danger">Eliminar</button>
              </td>
            </template>
          </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from './../../../application'
export default {
  name: "AcademicForm",
  props: ['project', 'academic_references'],
  data() {
    return {
      editing:false,
      loading:false,
      academicNameTemp:'',
      countries: [],
      country: '',
      cities: [],
      typeMessage: '',
      institutions: [],
      not_institution: false,
      not_have_references:true,
      message: '',
      academic_references_local: this.academic_references,
      academic_reference: {},
      academic_types: [
        { id: 1, name: "elemental" },
        { id: 2, name: "superior" }
      ],
      levels: [
        { id: 0, name: "Primaria" },
        { id: 1, name: "Bachiller" },
        { id: 2, name: "Profesional Universitario" },
        { id: 3, name: "Técnico Profesional" },
        { id: 4, name: "Otro" },
        { id: 5, name: "Tecnólogo" },
        { id: 6, name: "Especialista" },
        { id: 7, name: "Maestria" },
        { id: 8, name: "Doctorado" }
      ],
      observations: [
        { id: 1, name: "Se establece conexión en el número XXXXXX , donde la Señora XXXX, con cargo XXXXXX de la institución XXXXXX, confirma que el aspirante se graduó de la institución con documento de identidad XXXX, y quedó registrado bajo el acta XX, Numeral XX, Folio XX del año XXXX" },
        { id: 2, name: "RESPUESTA ICFES Tras revisar el portal http://www2.icfesinteractivo.gov.co/, se confirma que la aspirante con XXX No. XXX, presentó pruebas XXX el día XXXX, previo a la culminación de sus estudios de XXXX, su número de registro XXXX. Se graduó bajo Folio XXX Libro XXx" },
        { id: 3, name: "RESPUESTA SENA Tras revisar el portal http://certificados.sena.edu.co/ se confirma que la aspirante con xxx No. xxx, presentó y aprobó la carrera en mención según número de acta xxxx y número de registro xxxx en la fecha xxxxx " },
        { id: 4, name: "RESPUESTA CORREO Se recibe respuesta a través del correo XXXX donde la señora XXXX, confirma que el aspirante cursó y aprobó el programa en mención según Acta XXX folio XXXX" },
        { id: 5, name: "RESPUESTA TELEFONICA Se establece conexión al número XXXXX donde la señora XXXXXXX confirma que el aspirante efectivamente cursó y aprobó su XXXXX en la Institución XXXXXX, según Acta No XXX" },
        { id: 6, name: "RESPUESTA RETHUS Tras revisar en https://web.sispro.gov.co/THS/Cliente/ConsultasPublicas/ConsultaPublicaDeTHxIdentificacion.aspx se confirma que la aspirante con documento C.C. No. XXX efectivamente obtiene su Registro único Nacional de Talento Humano en Salud rethus donde la acredita como XXXX en la Entidad Reportadora XXX desde el XXXX" },
        { id: 7, name: "RESPUESTA TARJETA PROFESIONAL Tras revisar la pagina https://copnia.gov.co/atencion-al-ciudadano/consultas-en-linea/verifique-el-numero-de-matricula-profesional se confirma que la aspirante con documento C.C. No. XXX efectivamente obtiene su tarjeta profesional donde la acredita como XXXX bajo el No. XXXX del día XXXX" },
        { id: 8, name: "RESPUESTA APOSTILLAS Tras revisar la pagina http://validarlegalizaciones.mppre.gob.ve/validar_fra.php se confirma que el aspirante con documento XXX efectivamente obtiene sus títulos apostillados bajo el No. XXXXX Tras revisar la pagina http://romuloparraabogado.com/como-comprobar-la-validez-de-la-apostilla-de-la-haya se confirma que el aspirante efectivamente obtiene sus títulos apostillados y el documento presentado cuenta con las condiciones estipuladas para las apostillas manuales (Marca de Agua, fecha y firma del suscriptor); tiene validez en el país."},
        { id: 9, name: "RESPUESTA GRAFOLOGÍA Se valida certificado con aprobación de grafología, donde se evidencia que el documento cuenta con los sellos, firmas y formato manejado por la institución, adicional, no presenta tachones ni enmendaduras." }
      ],
      automations: [
        {
          id: '9112', name: 'Servicio nacional de aprendizaje (SENA)'
        }
      ],
      observations_ia: '',
      spinner: false,
      selected_obs_with_ia: 'obs_by_analist',
      disabeGPT: true
    };
  },
  methods: {
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    async saveReason () {
      this.setHeaders()
      if (this.not_have_references) this.project.reason_not_have_academic_references = null
      let request = await axios.put(`/update_information_project`, { project: { id: this.project.id, not_have_academic_references: this.not_have_references, reason_not_have_academic_references: this.project.reason_not_have_academic_references} })
      if (request.status == 200) {
        this.showMessage('Información guardada.', 'alert-success')
      }
    },
    getNameCity(city_id) {
      let city = this.cities.find( city => city.id == city_id)
      if (city != null) {
        return city.name
      } else {
        return ''
      }
    },
    async save() {
      this.$validator.validate().then(async (valid) => {
        if (!valid) {
          console.log('No es valido')
          return false
        }
        this.academic_reference.project_id = this.project.id
        const url = '/api/v1/academic_references/'
        this.setHeaders()
        if (this.academic_reference.id != null) { // put
          let request = await axios.put(`${url}${this.academic_reference.id}`, { academic_reference: this.academic_reference, observations_ia: this.observations_ia, selected_obs_with_ia: this.selected_obs_with_ia })
          if (request.status == 200) {
            this.showMessage('Referencia académica editada con exito', 'alert-success')
            this.editing = false
            this.country = null
            this.academic_reference = {}
            this.errors.items = []
            this.not_institution = false
          } else {
            this.showMessage('No se pudo editar la referencia académica', 'alert-danger')
          }
        } else { // post
          this.loading = true
          let request = await axios.post(url, { academic_reference: this.academic_reference, observations_ia: this.observations_ia, selected_obs_with_ia: this.selected_obs_with_ia })
          if (request.status == 201) {
            this.showMessage('Referencia académica creada con exito', 'alert-success')
            this.academic_references_local.push(request.data.academic_reference)
            this.academic_reference = {}
          } else {
            this.showMessage('No se pudo crear la referencia académica', 'alert-danger')
          }
          this.loading = false
        }
        this.observations_ia = ''
        this.selected_obs_with_ia = 'obs_by_analist'
        this.disabeGPT = true
      })
    },
    async callServiceChat () {
      this.spinner = true
      let request = await axios.get(`/artificial_grammar?text=${this.academic_reference.observations}`).then(res=>{
        console.log(res)
      this.spinner = true
        if (res.status == 200 || res.status == 201) {
          this.observations_ia = res.data.data
          this.disabeGPT = true
          this.selected_obs_with_ia = 'obs_by_analist'
        } else {
          console.log('Error')
          this.disabeGPT = false
        }
      this.spinner = false
			})
      this.spinner = false
    },
    async deleteAcademicReference (academic_reference, index) {
      const url = `/api/v1/academic_references/${academic_reference.id}`
      this.setHeaders()
      let request = await axios.delete(url)
      if (request.status == 200) {
        this.academic_references_local = this.academic_references_local.filter( academic_reference_iterator => academic_reference_iterator.id != academic_reference.id )
        this.showMessage('Referencia académica eliminada con exito', 'alert-success')
      } else {
        this.showMessage('No se pudo eliminar la referencia académica', 'alert-danger')
      }
    },
    async edit (academic_reference) {
      this.academicNameTemp = academic_reference.name_institution
      delete academic_reference.name_institution
      this.editing = true
      this.loading = true
      await this.getCountryByCity(academic_reference.city_id)
      this.academic_reference = academic_reference
      let academic_type = this.academic_types.find( academic_type => academic_type.name == academic_reference.academic_type )
      if (academic_type != null) {
        this.academic_reference.academic_type = academic_type.id
      }
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },
    async getCountries(){
      let {data} = await axios.get('/api/v1/countries')
      this.countries = data.countries
    },

    async getCountryByCity(cityId){
      let result = await axios.get('/api/v1/country_by_city/'+cityId)
      this.country = result.data.country_id
    },
    async getCities(country_id) {
      let { data } = await axios.get(`/api/v1/cities?country_id=${country_id}`)
      this.cities = data.cities
      eventBus.$emit('cities')
    },

    async getInstitutions(cityId) {
    axios.defaults.headers.common["Accept"] = "*/*";

    const city = this.cities.find(c => c.id == cityId);
    if (!city) {
      this.institutions = [];
      eventBus.$emit('institutions');
      return;
    }

    const { cod_mpio } = city;

    this.institutions = [];

    try {
      const { data } = await axios.get(
        `https://www.datos.gov.co/resource/n5yy-8nav.json?cod_municipio=${cod_mpio}`,
        { timeout: 10000 }
      );

      this.institutions = Array.isArray(data) ? data : [];
    } catch (err) {
      console.warn("No se pudo cargar instituciones desde datos.gov.co", {
        cod_mpio,
        message: err?.message,
        status: err?.response?.status,
      });

    }

    if (!['11001','76001','05001','25473','63001','76111'].includes(cod_mpio)) {
      this.institutions.push({
        c_digo_instituci_n: '9112',
        nombre_instituci_n: 'SERVICIO NACIONAL DE APRENDIZAJE-SENA-'
      });
    }

    eventBus.$emit('institutions');
  },
  async getInstitutionsByName(name) {
    this.institutions = [];

    const q = (name ?? "").toString().trim();
    if (!q) return;

    try {
      const encoded = encodeURIComponent(q.toUpperCase());
      const url = `https://www.datos.gov.co/resource/n5yy-8nav.json?$where=nombre_instituci_n like '%25${encoded}%25'`;

      const { data } = await axios.get(url, { timeout: 10000 });

      this.institutions = Array.isArray(data) ? data : [];
    } catch (err) {
      console.warn("No se pudo buscar instituciones por nombre en datos.gov.co", {
        name: q,
        message: err?.message,
        status: err?.response?.status,
      });

    }
  },

    async rulesForSearch(){
      this.institutions = []

      if (this.country != 1) {
        return false
      }

      if (this.academic_reference.level > 1) {
        this.getInstitutions(this.academic_reference.city_id)
      }
    },
    goToComposeEmail(projectId, referenceType, referenceId) {
      const basePath = '/reference_consultation';

      const params = new URLSearchParams({
        project_id: projectId,
        reference_type: referenceType,
        reference_id: referenceId,
      });

      window.location.href = `${basePath}?${params.toString()}`
    }
  },
  filters: {
    academicTypeName: function (value) {
      let academic_type_name = ''
      if (typeof value === 'number') {
        switch (value) {
          case  1:
            academic_type_name = "elemental"
            break;
          case  2:
            academic_type_name = "superior"
            break;
          default:
            academic_type_name = ""
            break;
        }
      }
      if (academic_type_name != '') {
        value = academic_type_name
      }
      return value
    },
    levelName: function (value) {
      let level_name = ''
      switch (value) {
        case  0:
          level_name = "Primaria"
          break;
        case  1:
          level_name = "Bachiller"
          break;
        case  2:
          level_name = "Profesional Universitario"
          break;
        case  3:
          level_name = "Técnico Profesional"
          break;
        case  4:
          level_name = "Otro"
          break;
        case  5:
          level_name = "Tecnólogo"
          break;
        case  6:
          level_name = "Especialista"
          break;
        case  7:
          level_name = "Maestria"
          break;
        case  8:
          level_name = "Doctorado"
          break;
        default:
          level_name = ""
          break;
      }
      return level_name
    },
    trueOrFalse: function(value) {
      if(value) {
        return 'Si'
      }else {
        return 'No'
      }
    }
  },
  created(){
    this.getCountries()
    eventBus.$on('cities', () => {
      if(this.editing) {
        this.getInstitutions(this.academic_reference.city_id)
      }
    })

    eventBus.$on('institutions', () => {
      if(this.editing) {
        this.academic_reference.name_institution = this.academicNameTemp
        if (!this.academic_reference.code && this.academic_reference.level > 1) {
          this.not_institution = true
        }
        this.loading = false
      }

    })
  },
  watch:{
    country(val) {
      this.getCities(val)
    },
    'academic_reference.level'(level) {
      this.rulesForSearch()
    },
    async not_institution(val) {
      if (val == false) await this.getInstitutions(this.academic_reference.city_id)
    },
    'academic_reference.name_institution'(name) {
      if(this.academic_reference.level > 1 && this.country == 1 && !this.not_institution) {
      let {c_digo_instituci_n} = this.institutions.find( item => item.nombre_instituci_n == name)
      this.academic_reference.code = c_digo_instituci_n
      }
    },
    'academic_reference.observations'(value){
      if(value !== ''){
        this.disabeGPT = false
      } else {
        this.disabeGPT = true
      }
    }
  },
  mounted () {
    if (this.project != null) {
      if (this.project.not_have_academic_references) {
        this.not_have_references = true
      } else {
        this.not_have_references = false
      }
      if (this.academic_references_local.length > 0) this.not_have_references = true
    }
  },
};
</script>

<style>
  .no-resize{
    resize: none;
  }
</style>
